var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.multiple)?_c('div',[_c('AutoComplete',{attrs:{"autocomplete":"off","table":_vm.input.table,"field":_vm.input.name},on:{"okeyto":aa => _vm.setModel(aa)}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }